import { render, staticRenderFns } from "./FlsData.vue?vue&type=template&id=f7c0fcec&scoped=true&"
import script from "./FlsData.vue?vue&type=script&lang=js&"
export * from "./FlsData.vue?vue&type=script&lang=js&"
import style0 from "./FlsData.vue?vue&type=style&index=0&id=f7c0fcec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c0fcec",
  null
  
)

export default component.exports